import { render, staticRenderFns } from "./FamilyIcon.vue?vue&type=template&id=a88d4f36&scoped=true"
import script from "./FamilyIcon.vue?vue&type=script&lang=js"
export * from "./FamilyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88d4f36",
  null
  
)

export default component.exports